<!-- 弹框 -->
<template>
    <el-dialog
        :id="id"
        custom-class="window-dialog"
        :top="top"
        :visible.sync="dSHow"
        :before-close="handleCancel"
        :close-on-click-modal="false"
        :width="width"
        :append-to-body="true"
    >
        <template slot="title">
            <div class="title">{{ title }}</div>
            <div
                v-if="subTitle"
                class="subTitle"
            >{{ subTitle }}
            </div>
        </template>
        <slot name="bodyContent" />
        <template
            v-if="showFooter"
            slot="footer"
        >
            <el-button
                v-if="showCancel"
                size="mini"
                @click="handleCancel"
            >{{ $t('取消') }}
            </el-button>
            <el-button
                size="mini"
                type="primary"
                :loading="loading"
                @click="handleSure"
            >{{ $t('确认') }}
            </el-button>
        </template>
    </el-dialog>
</template>
<script>

export default {
    name: 'WinDialog',
    components: {},
    props: {
        showCancel: {
            default: true
        },
        top: {
            type: String,
            default: '15vh'
        },
        // id
        id: {
            type: String,
            default: ''
        },
        // 标题
        title: {
            type: String,
            default: '提示',
            require: true
        },
        // 二级标题
        subTitle: {
            type: String,
            default: ''
        },
        handleClose: {
            type: Function,
            default: () => {
                return () => {
                }
            }
        },
        // 取消回调
        cancel: {
            type: Function,
            default: null
        },
        // 确定回调
        sure: {
            type: Function,
            default: null
        },
        // 弹框显示隐藏
        dialogShow: {
            type: Boolean,
            default: false
        },
        // 显示底部按钮
        showFooter: {
            type: Boolean,
            default: true
        },
        width: {
            type: String,
            default: '700px'
        },
        // 弹框关闭后的方法
        closeAfter: {
            type: Function,
            default: () => {
                return () => {
                }
            }
        }
    },
    data() {
        return {
            loading: false
        }
    },

    computed: {
        dSHow() {
            return this.dialogShow
        }
    },

    watch: {},

    mounted() {
    },

    methods: {
        // 取消方法
        handleCancel() {
            if (typeof this.cancel === 'function') {
                this.cancel(() => {
                    this.closeDialog()
                })
            } else {
                this.closeDialog()
            }
        },
        // 确认方法
        handleSure() {
            this.loading = true
            if (typeof this.sure === 'function') {
                this.sure(() => {
                    this.closeDialog()
                })
            } else {
                this.closeDialog()
            }
            this.loading = false
        },
        // 弹框关闭
        closeDialog() {
            this.$emit('update:dialogShow', false)
            this.closeAfter()
        }
    }
}
</script>
<style lang="stylus">

.window-dialog {
    width: 700px;
    height:80%;

    .el-dialog__header {
        background: $color-main;
        padding: 12px 20px;
        box-sizing: border-box;
        color: $color-white;

        .title {
            font-size: 18px;
            font-weight: 500;
        }

        .subTitle {
            margin-top: 4px;
            font-size: 12px;
            font-weight: 400;
        }
    }

    .el-dialog__body {
        padding: 24px;
        height:80%;
        overflow-y:auto;
    }

    .el-dialog__close {
        color: $color-white;
        opacity: .65;
    }

    .el-dialog__headerbtn {
        top: 13px;

        &:hover {
            .el-dialog__close {
                color: $color-white;
                opacity: 1;
            }
        }
    }

    .el-dialog__footer {
        text-align: center
        padding:0 !important;
    }
}
</style>
